module.exports = __webpack_public_path__ + "media/assets/images/number-plate-green-3b37c2238e3499a1978ec7c54bf57d28.png";